import { Suspense, lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";

import { Layout } from "./Layout";
import { ApiKeys } from "./pages/ApiKeys";
import { BalancePage } from "./pages/BalancePage";
import { CallerIds } from "./pages/CallerIds";
import { CallDetail } from "./pages/CallDetail";
import { Calls } from "./pages/Calls";
import { Dashboard } from "./pages/Dashboard";
import { Limits } from "./pages/Limits";
import { Live } from "./pages/Live";
import { Login } from "./pages/Login";
import { Nodes } from "./pages/Nodes";
import { Numbers } from "./pages/Numbers";
import { Playground } from "./pages/Playground";
import { Rates } from "./pages/Rates";
import { Security } from "./pages/Security";
import { Tenants } from "./pages/Tenants";
import { Trunks } from "./pages/Trunks";
import { UsagePage } from "./pages/UsagePage";
import { Users } from "./pages/Users";
import { VoiceApps } from "./pages/VoiceApps";
import { Webhooks } from "./pages/Webhooks";

// El login queda **fuera** del layout: el layout exige sesión, y meter el
// login dentro haría que la pantalla de entrada redirigiera a sí misma.
//
// Las rutas no llevan guardia de permiso: la autorización real vive en el
// backend (§6) y el filtro del menú ya oculta lo que no aplica. Teclear una
// ruta a mano sin permiso muestra el error de la API, que es lo correcto —
// esconder la ruta no es un control de acceso.
export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  // La documentación es pública: la lee el desarrollador del cliente, que
  // todavía no tiene cuenta. Pedirle que entre para leer cómo se entra sería
  // el problema del huevo y la gallina.
  { path: "/docs", element: <DocsDiferida /> },
  { path: "/docs/:guia", element: <DocsDiferida /> },
  {
    path: "/",
    element: <Layout />,
    children: [
      // La raíz va al tablero desde la Fase 6: es lo que alguien abre el
      // portal para ver por la mañana, y las llamadas están a un clic.
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <Dashboard /> },
      // «En curso» es su propia pantalla y no un bloque del tablero: ver
      // `pages/Live.tsx`.
      { path: "live", element: <Live /> },
      { path: "calls", element: <Calls /> },
      { path: "calls/:callId", element: <CallDetail /> },
      { path: "voice-apps", element: <VoiceApps /> },
      { path: "numbers", element: <Numbers /> },
      { path: "caller-ids", element: <CallerIds /> },
      { path: "webhooks", element: <Webhooks /> },
      { path: "playground", element: <Playground /> },
      { path: "balance", element: <BalancePage /> },
      { path: "usage", element: <UsagePage /> },
      { path: "limits", element: <Limits /> },
      { path: "api-keys", element: <ApiKeys /> },
      { path: "users", element: <Users /> },
      { path: "security", element: <Security /> },
      { path: "rates", element: <Rates /> },
      { path: "nodes", element: <Nodes /> },
      { path: "trunks", element: <Trunks /> },
      { path: "tenants", element: <Tenants /> },
    ],
  },
]);

// La documentación se carga aparte: trae su propio renderizador de markdown, y
// quien entra al portal a operar llamadas no tiene por qué descargarlo.
const Docs = lazy(() => import("./pages/Docs").then((m) => ({ default: m.Docs })));

function DocsDiferida() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">
          Cargando la documentación…
        </div>
      }
    >
      <Docs />
    </Suspense>
  );
}
